import React from 'react';
import ReactDOM from 'react-dom';
import { List } from 'immutable';
import URI from 'urijs';
import fetch from 'utils/fetch';
import { setSelectionCount } from 'plugins/action-bar';
import { SortDirection } from 'react-virtualized';
import AsyncInfiniteList from 'common/components/AsyncInfiniteList';
import CheckboxInfiniteList from 'common/components/CheckboxInfiniteList';
import { getCurrentFilters } from 'plugins/search';

export const columnWidth = (width, columnWidth) => width / 16 * columnWidth;

export const renderList = (
  rowClickedUrl,
  loadNextUrl,
  renderColumns,
  params = {}
) => {
  return render(
    rowClickedUrl,
    loadNextUrl,
    (total, entities, rowClicked, loadNext) => (
      <AsyncInfiniteList
        initialData={List(entities)}
        totalCount={total}
        loadNext={loadNext}
        renderColumns={renderColumns}
        onRowClick={rowClicked}
        {...params}
      />
    )
  );
};

export const renderCheckboxList = (
  rowClickedUrl,
  loadNextUrl,
  renderColumns,
  customRowRenderer = undefined,
  params = {}
) => {
  const onAllSelected = () => {
    doRender(true);
  };

  function doRender(all = false) {
    return render(
      rowClickedUrl,
      loadNextUrl,
      (total, entities, rowClicked, loadNext) => (
        <CheckboxInfiniteList
          entities={entities}
          total={total}
          all={all}
          loadNext={loadNext}
          renderColumns={renderColumns}
          onRowClick={rowClicked}
          onSelectionChanged={setSelectionCount}
          onAllSelected={onAllSelected}
          customRowRenderer={customRowRenderer}
          {...params}
        />
      ),
      all
    );
  }

  doRender();
};

function render(rowClickedUrl, loadNextUrl, renderComponent, all = false) {
  const root = document.getElementById('root');
  const initialData = __INITIAL_DATA__;

  if (root && initialData) {
    const { total, entities } = initialData;

    const rowClicked = row => {
      const url = rowClickedUrl(row.id);
      if (url) {
        window.location.assign(rowClickedUrl(row.id));
      }
    };

    const loadNext = (startIndex, stopIndex, sort) =>
      new Promise((resolve, reject) => {
        // Retrieve current search input value if exists

        const serializedSearch = getCurrentFilters();
        console.log(serializedSearch);

        const fixedLimit = Math.min(40, total - startIndex);

        // console.group('Load next');
        // console.log('Start: ' + startIndex);
        // console.log('Stop: ' + stopIndex);
        // console.log('Fixed Limit:' + fixedLimit);
        // console.groupEnd();

        const sortField = serializeSort(sort);

        const sortObj = () => {
          if (sortField.length > 0) {
            return {
              sort: sortField,
            };
          } else {
            return {};
          }
        };

        const fetchUrl = new URI(loadNextUrl).query({
          starting_after: all ? 0 : startIndex,
          limit: all ? total : fixedLimit,
          start_index: all ? 0 : startIndex, // doobie range cursor
          ...serializedSearch,
          ...sortObj(), // rangesort must be null if sort is empty for controller using doobie range
        });

        fetch(fetchUrl)
          .then(res => res.json())
          .then(range => resolve(range), error => reject(error));
      });

    ReactDOM.unmountComponentAtNode(root);

    return ReactDOM.render(
      renderComponent(
        total,
        all ? [entities[0]] : entities,
        rowClicked,
        loadNext
      ),
      root
    );
  }

  return null;
}

function serializeSort({ sortBy, sortDirection }) {
  if (sortBy && sortDirection) {
    switch (sortDirection) {
      case SortDirection.ASC:
        return sortBy;
      default:
        return `-${sortBy}`;
    }
  }

  return '';
}



// WEBPACK FOOTER //
// ./src/utils/async-list.js